import type { Route } from '@angular/router';
import { SigninLayoutComponent } from '@chaman/layouts';
import { getAuthGuard } from '@chaman/guards';
import { GUARD_SETTINGS } from '../core/consts/auth-guard.config';
import { AppLayoutComponent } from '../shared/layouts';

const authGuard = getAuthGuard(GUARD_SETTINGS);

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'auth/signin',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: SigninLayoutComponent,
    children: [
      {
        path: 'signin',
        loadComponent: () =>
          import('./auth/signin/signin.component').then(
            (m) => m.SigninComponent
          ),
      },
    ],
  },
  {
    path: 'profile',
    component: AppLayoutComponent,
    loadChildren: () =>
      import('./profile/profile.routes').then((m) => m.profileRoutes),
  },
  {
    path: 'doctor-appointment',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./doctor-appointment/doctor-appointment.routes').then(
        (m) => m.doctorRoutes
      ),
  },
  {
    path: 'payment-links',
    loadChildren: () =>
      import('./payment-link/payment-link.routes').then(
        (m) => m.paymentLinkRoutes
      ),
  },
];
